import type { ReactNode } from 'react';
import { AuthProvider as OidcAuthProvider } from 'react-oidc-context';

import { useAuthProvider } from '@/hooks/use-auth-provider';

type AuthProviderProps = {
  children: ReactNode;
};

export const AuthProvider = ({ children }: AuthProviderProps) => {
  const { onSigninCallback, userManager } = useAuthProvider();

  return (
    <OidcAuthProvider
      onSigninCallback={onSigninCallback}
      userManager={userManager}
    >
      {children}
    </OidcAuthProvider>
  );
};
